import React from 'react';
import PbssInContainer from '../../../Containers/UserContainer/PbssInternational';

const PbssInScreen = () => {
  return <PbssInContainer />;
};

export default PbssInScreen;
